import React from 'react';

const TrashIcon = (props) => {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.34499 3.8125V11.0702C3.34499 11.5131 3.70403 11.8721 4.14692 11.8721H9.85045C10.2933 11.8721 10.6524 11.5131 10.6524 11.0702V3.8125M1.69531 3.8125H12.3014"
          stroke="currentColor"
          strokeWidth="0.991667"
          strokeLinecap="round"
        />
        <path
          d="M4.66211 3.5V2.57496C4.66211 2.11935 5.03146 1.75 5.48707 1.75H8.50383C8.95941 1.75 9.32878 2.11935 9.32878 2.57496V3.5"
          stroke="currentColor"
          strokeWidth="0.991667"
          strokeLinecap="round"
        />
      </svg>
    );
};

export default TrashIcon;
